// extracted by mini-css-extract-plugin
module.exports = {"vcdLink":"VcdLink_vcdLink__HzdIr","vcdLinkButton":"VcdLink_vcdLinkButton__Ga_Rf"};